<template>
  <div>
    <div v-if="isLoading" class="flex items-center justify-center h-52">
      <aha-spinner size="lg" variant="tail" />
    </div>

    <template v-if="!isLoading">
      <ErrorSlideCopy v-if="hasError" @getAllUserPresentationsAndFolders="loadData" />
      <Folders
        v-if="hasPresentationToCopyTo"
        :selectedPresentationId="presentationId"
        :folders="folders"
        :presentations="allowToCopyToPresentations"
        @handlePresentationItemClick="handlePresentationItemClick"
      ></Folders>
      <template v-if="!hasError">
        <NoPresentationSlideCopy v-if="!hasPresentationToCopyTo" />
      </template>
    </template>
    <slot v-if="hasPresentationToCopyTo" name="interactive-button-section">
    </slot>
  </div>
</template>
<script>
import TabBaseMixin from './TabBaseMixin'
import Folders from './Folders.vue'
import SlideCopy from '../SlideCopy.vue'

export default {
  name: 'TabPresentations',
  title: 'My Presentations',
  components: {
    Folders,
  },
  extends: SlideCopy,
  mixins: [TabBaseMixin],
  methods: {
    async loadData() {
      return this.getAllUserPresentationsAndFolders()
    },
  },
}
</script>
